export default __webpack_public_path__ + "static/media/ice.c82bd829.svg";